import { COLORS } from "../../utils/colors";
import "./style.css";

export const LoaderAnimation = {
  __loader: null,
  show: function () {
    if (this.__loader == null) {
      var divContainer = document.createElement("div");
      divContainer.style.position = "fixed";
      divContainer.style.left = "0";
      divContainer.style.top = "0";
      divContainer.style.width = "100%";
      divContainer.style.height = "100%";
      divContainer.style.zIndex = "9998";
      divContainer.style.backgroundColor = "rgba(250, 250, 250, 0.80)";
      divContainer.style.display = "flex";
      divContainer.style.justifyContent = "center";
      divContainer.style.alignItems = "center";

      var spinnerDiv = document.createElement("div");
      spinnerDiv.style.height = "32px";
      spinnerDiv.style.width = "32px";
      spinnerDiv.style.border = `4px solid ${COLORS.THEME_COLOR}`;
      spinnerDiv.style.borderRadius = "50%";
      spinnerDiv.style.borderTopColor = "rgba(251,227,211,255)";
      spinnerDiv.style.borderRightColor = "rgba(251,227,211,255)";
      spinnerDiv.style.position = "relative";
      spinnerDiv.style.animation = "spin 1s linear infinite";

      divContainer.appendChild(spinnerDiv);
      this.__loader = divContainer;
      document.body.appendChild(this.__loader);
    }
    this.originalOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    this.__loader.style.display = "flex"; // Make sure the container is displayed
  },
  hide: function () {
    if (this.__loader != null) {
      this.__loader.style.display = "none";
      document.body.style.overflow = this.originalOverflow;
    }
  },
};
